import { sendToLogServer } from "../core/service/BusinessLogicService"
import { apigateway } from "../intances/apigateway"
import { getUsername } from "./authorization"

const linkDocumentPagesWithSupportingPageIds = (supportingPagesBySelectedTypeOfDoc, documentPages) => {
  const linkedDocumentsWithSupportingDocumentIds = supportingPagesBySelectedTypeOfDoc.map((option, index) => {
    if (documentPages[index]) {
      return { ...documentPages[index], ...(documentPages[index].id = option.id) }
    }
    return null
  })
  return linkedDocumentsWithSupportingDocumentIds.filter((doc) => doc !== null)
}

const fetchPdiLoggedUser = async (tunnelData) => {
  const headers = {
    Authorization: `Bearer ${tunnelData?.access_token}`,
    "Content-Type": "application/json"
  }
  const userLogin = getUsername()
  const fetchBody = { login: userLogin }
  return apigateway(tunnelData)
    .post(`${tunnelData.apiUrl}middle-business-service/api/v1/users/search`, JSON.stringify(fetchBody), {
      headers
    })
    .then((res) => {
      return res.data.id
    })
    .catch((error) => {
      sendToLogServer(
        "ERROR",
        `There was an error in middle-business-service/api/v1/users/search endpoint | login : ${userLogin} opl : ${
          tunnelData.opl
        } : ${JSON.stringify(error)}`
      )
    })
}

export const postUploadDocument = async ({ datas, tunnelData, transactionId, documentTypesOptions }) => {
  const { documentPages, typeOfDocument } = datas
  const supportingDocumentId = typeOfDocument.value

  const supportingPagesBySelectedTypeOfDoc = documentTypesOptions?.filter(
    (option) => option.id === supportingDocumentId
  )?.[0]?.supportingPages

  const validLinkedFilesWithIds = linkDocumentPagesWithSupportingPageIds(
    supportingPagesBySelectedTypeOfDoc,
    documentPages
  )

  const form = new FormData()
  validLinkedFilesWithIds.forEach((document) => {
    form.append(`${document.id.toString()}`, document.file)
  })

  const supportingDocumentCriteriaDTO = {
    transactionId,
    targetId: transactionId,
    userId: await fetchPdiLoggedUser(tunnelData)
  }

  form.append("supportingDocumentCriteriaDTO", JSON.stringify(supportingDocumentCriteriaDTO))

  const headers = {
    Authorization: `Bearer ${tunnelData?.access_token}`,
    Accept: "application/json",
    "Content-Type": "multipart/form-data"
  }

  // BusinessAPI.V1.TRANSACTION.SUPPORTING_PAGE_SCAN_UPLOAD,
  const SUPPORTING_DOCUMENT_UPLOAD_URI = `${tunnelData.apiUrl}middle-business-service/api/v1/transactions/${transactionId}/supporting-documents/${supportingDocumentId}/upload`

  return await apigateway(tunnelData)
    .post(SUPPORTING_DOCUMENT_UPLOAD_URI, form, {
      headers
    })
    .then((res) => {
      return res.data
    })
    .catch((error) => {
      console.error("postUploadDocument error : \n", error, error.response)
      const errorMessage = error.response?.data ? error.response.data : new Error("error from postUploadDocument")

      sendToLogServer(
        "ERROR",
        `There was an error in middle-business-service/api/v1/transactions/${transactionId}/supporting-documents/${supportingDocumentId}/upload endpoint${
          tunnelData.opl
        } : ${JSON.stringify(error.response)}`
      )
      throw errorMessage
    })
}
